<div class="incident-handling-step">
  <h3 class="mb-3">Incident Handling Configuration</h3>
  <form
    [formGroup]="incidentHandlingForm"
    class="row g-3"
  >
    <div class="col-12">
      <kendo-formfield>
        <kendo-label
          [for]="incidentHandlingEmail"
          text="Incident Handling Email *"
        ></kendo-label>
        <kendo-textbox
          formControlName="incidentHandlingEmail"
          #incidentHandlingEmail
          placeholder="Enter incident handling email address"
          class="w-100"
        ></kendo-textbox>
        @if (
          incidentHandlingForm.get('incidentHandlingEmail')?.invalid &&
          incidentHandlingForm.get('incidentHandlingEmail')?.touched
        ) {
          <kendo-formerror>Valid email address is required</kendo-formerror>
        }
      </kendo-formfield>
    </div>

    <div class="col-12">
      <h4 class="mb-3">IR Contacts</h4>
      <div
        class="ir-contacts-container"
        formArrayName="irContacts"
      >
        <!-- Display existing IR Contacts -->
        @for (contact of irContacts(); track $index) {
          <div
            class="ir-contact-item mb-3"
            [formGroupName]="$index"
          >
            <div class="contact-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">IR Contact #{{ $index + 1 }}</h6>
              <button
                type="button"
                class="btn-remove"
                (click)="removeIrContact($index)"
                title="Remove contact"
                aria-label="Remove IR contact"
              >
                <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
              </button>
            </div>
            <div class="row g-3">
              <div class="col-md-4">
                <kendo-formfield>
                  <kendo-label
                    [for]="'contactName' + $index"
                    text="Name *"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="name"
                    [id]="'contactName' + $index"
                    placeholder="Enter contact name"
                    class="w-100"
                  ></kendo-textbox>
                  @if (contact.get('name')?.invalid && contact.get('name')?.touched) {
                    <kendo-formerror>Contact name is required</kendo-formerror>
                  }
                </kendo-formfield>
              </div>
              <div class="col-md-4">
                <kendo-formfield>
                  <kendo-label
                    [for]="'contactEmail' + $index"
                    text="Email *"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="email"
                    [id]="'contactEmail' + $index"
                    placeholder="Enter contact email"
                    class="w-100"
                  ></kendo-textbox>
                  @if (contact.get('email')?.invalid && contact.get('email')?.touched) {
                    <kendo-formerror>Valid email address is required</kendo-formerror>
                  }
                </kendo-formfield>
              </div>
              <div class="col-md-4">
                <kendo-formfield>
                  <kendo-label
                    [for]="'contactPhone' + $index"
                    text="Phone *"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="phone"
                    [id]="'contactPhone' + $index"
                    placeholder="Enter contact phone"
                    class="w-100"
                  ></kendo-textbox>
                  @if (contact.get('phone')?.invalid && contact.get('phone')?.touched) {
                    <kendo-formerror>Contact phone is required</kendo-formerror>
                  }
                </kendo-formfield>
              </div>
            </div>
          </div>
        }

        <!-- Add IR Contact Button -->
        <div class="text-center">
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="addIrContact()"
          >
            <i class="bi bi-plus-circle me-2"></i>
            Add IR Contact
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
